
import '../Services.css';
import img from '../../../assets/catogory/Residential_Plots/img2.jpg'; // Generic property image
import PropertyAdvantage from '../../../components/PropertyAdvantage/PropertyAdvantage';
import ConversationSection from '../../../components/ConversationSection/ConversationSection';

const BuySellProperties = () => {
    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Buy & Sell Properties</h1>
            </div>
            <section className="service-split-section">
                <div className="service-split-container">
                    <div className="service-left">
                        <span className="service-badge-pill">Success, Together</span>
                        <h2 className="service-split-title">Buy & Sell Properties</h2>
                        <p className="service-split-text">
                            At Jeevan Realty, we simplify every aspect of buying and selling—whether you are a property owner looking
                            to sell or a buyer searching for your dream home. Our comprehensive real estate services ensure
                            transparency, fair valuation, and complete peace of mind throughout the transaction.
                        </p>
                    </div>
                    <div className="service-right">
                        <img src={img} alt="Buy sell Properties" />
                    </div>
                </div>
            </section>

            <div className="service-steps-container">
                <div className="service-steps-list">
                    {/* Step 1 */}
                    <div className="service-step-card">
                        <div className="service-step-number">1</div>
                        <div className="service-step-content">
                            <h3>Initial Consultation</h3>
                            <p>We start by getting to know you—your budget, goals, and preferred location. Whether you’re buying or selling, this personalized session helps us understand exactly what you need in a property transaction</p>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="service-step-card">
                        <div className="service-step-number">2</div>
                        <div className="service-step-content">
                            <h3>Valuation & Financial Preparation</h3>
                            <p>For buyers, we connect you with trusted mortgage partners to determine your purchasing power. For sellers, we provide a detailed property valuation so you can price competitively in today’s market.</p>
                        </div>
                    </div>

                    {/* Step 3 */}
                    <div className="service-step-card">
                        <div className="service-step-number">3</div>
                        <div className="service-step-content">
                            <h3>Property Search & Marketing</h3>
                            <p><strong>Buyers:</strong> Explore curated listings that match your lifestyle and investment goals.<br />
                                <strong>Sellers:</strong> We create a tailored marketing plan with professional photos, online listings, and targeted campaigns to reach qualified property buyers..</p>
                        </div>
                    </div>

                    {/* Step 4 */}
                    <div className="service-step-card">
                        <div className="service-step-number">4</div>
                        <div className="service-step-content">
                            <h3>Site Visits & Offers</h3>
                            <p>We schedule property tours at your convenience and guide you through every visit. When you’re ready, we help draft strong offers—or, if you’re selling, negotiate the best deal on your property</p>
                        </div>
                    </div>

                    {/* Step 5 */}
                    <div className="service-step-card">
                        <div className="service-step-number">5</div>
                        <div className="service-step-content">
                            <h3>Legal & Documentations</h3>
                            <p>From agreement drafting to title verification and DTCP/RERA checks, our team ensures every property document is accurate and compliant, giving you complete peace of mind.</p>
                        </div>
                    </div>

                    {/* Step 6 */}
                    <div className="service-step-card">
                        <div className="service-step-number">6</div>
                        <div className="service-step-content">
                            <h3>Closing & Handover</h3>
                            <p>On the final day, we coordinate with banks, legal experts, and registrars for a smooth transfer of ownership. Buyers receive their property, and sellers complete the transaction with confidence.</p>
                        </div>
                    </div>
                </div>
            </div>


            <PropertyAdvantage />
            <ConversationSection />
        </div>
    );
};

export default BuySellProperties;
